module.exports = __webpack_public_path__ + "static/media/refund-badge.04f23783.png";